import { AuthProviderProps } from 'react-oidc-context'
import { WebStorageStateStore } from 'oidc-client-ts'

const keycloakUrl = import.meta.env.VITE_KEYCLOAK_URL ?? ''

export const oidcConfig: AuthProviderProps = {
  authority: keycloakUrl,
  client_id: `mac`,
  redirect_uri: window.location.href,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  onSigninCallback: (): void => {
    window.history.replaceState({}, document.title, window.location.pathname)
  },
  post_logout_redirect_uri: window.location.origin,
  scope: 'openid foto profile matricula orgaos cargo roles orgaoExterno clients-access isInternal',
  metadata: {
    issuer: keycloakUrl,
    authorization_endpoint: `${keycloakUrl}/protocol/openid-connect/auth`,
    token_endpoint: `${keycloakUrl}/protocol/openid-connect/token`,
    introspection_endpoint: `${keycloakUrl}/protocol/openid-connect/token/introspect`,
    userinfo_endpoint: `${keycloakUrl}/protocol/openid-connect/userinfo`,
    end_session_endpoint: `${keycloakUrl}/protocol/openid-connect/logout`,
    jwks_uri: `${keycloakUrl}/protocol/openid-connect/certs`,
    check_session_iframe: `${keycloakUrl}/protocol/openid-connect/login-status-iframe.html`,
    registration_endpoint: `${keycloakUrl}/clients-registrations/openid-connect`,
    revocation_endpoint: `${keycloakUrl}/protocol/openid-connect/revoke`,
  },
}
